/**
 * Kennung fuer die Praesenz-Route der API (`/projects/:id/presence?app=…`).
 *
 * Die Route sucht das Projekt in der Projekt-DB ihrer App (luzula-api
 * routes/projects.logik.js): boden -> boden-projekte, bpwebmv -> bpweb-mv-projekte,
 * im Dev-Modus mit `-dev`. Bis 08.10.2026 stand hier fest 'bpweb'/'bpweb-dev' - das
 * las Datenbanken, in denen die Projekte von boden und bpweb.luzula.de nie lagen:
 * Jeder Heartbeat (alle 2 min je offenem Projekt) endete mit 404, und 404er zaehlen
 * bei der IP-Sperre (CrowdSec) mit.
 *
 * Fuer Varianten, deren Projekt-DB die API nicht kennt (lfmv: bpweb-* auf der
 * LFMV-Couch), gibt es null - dann meldet die App keine Praesenz.
 *
 * @param dbNamensraum APP_CONFIG.appName (= environment.dbBaseName)
 */
const API_APP_JE_NAMENSRAUM: Record<string, string> = {
	'boden': 'boden',
	'bpweb-mv': 'bpwebmv',
};

export function praesenzApp(dbNamensraum: string | undefined, istDevelopment: boolean): string | null {
	const app = dbNamensraum ? API_APP_JE_NAMENSRAUM[dbNamensraum] : undefined;
	if (!app) return null;
	return istDevelopment ? `${app}-dev` : app;
}
